import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Pagination } from "@mui/material";
import { Flex } from "@100mslive/roomkit-react";
import FullPageProgress from "../FullPageProgress";
import { ToastManager } from "../Toast/ToastManager";
import AIChatHistoryItem from "./AIChatHistoryItem";
import AIChatTabs from "./AIChatTabs";
import { SESSION_AUTH } from "../../common/auth";
import { CHAT_SERVICES } from "../../services";
import "./style.scss";

const AIChatHistory = () => {
  const { listType } = useParams();
  const { isUserSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const [userData, setUserData] = useState("");
  const navigate = useNavigate();
  const historyTabs = {
    query: "My Conversations",
    shared: "Shared with me",
  };
  const [listData, setListData] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [toggleState, setToggleState] = useState(
    historyTabs[listType] ? listType : "query"
  );
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [dataFetched, setDataFetched] = useState(false);

  useEffect(() => {
    if (isUserSession) {
      setUserData(isUserSession);
    } else {
      navigate("/ai/chat");
    }
  }, [isUserSession, navigate]);

  useEffect(() => {
    if (!userData || dataFetched) return;
    setDataFetched(true);
    setLoading(true);

    let parma = {
      userId: userData.userId,
      org: userData?.org?.id,
      page: page,
      limit: 50,
    };
    if (toggleState === "query") {
      CHAT_SERVICES.getHistoryList(parma)
        .then(data => {
          if (data.code === 200) {
            setListData(data?.data?.list);
            if (data.data?.pageInfo?.page === 1) {
              setTotalPage(data.data?.pageInfo?.totalPage || 0);
            } else {
              setListData(old => [...old, ...data.data]);
            }
          } else if (data.code === 600) {
            LOGOUT_USER_SESSION();
          } else {
            ToastManager.addToast({ title: data.message });
          }
        })
        .catch(error => {
          ToastManager.addToast({ title: error.message });
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [userData, dataFetched, page, toggleState, navigate, LOGOUT_USER_SESSION]);

  const changeTabs = item => {
    if (item !== toggleState) {
      setToggleState(item);
      setPage(1);
      setDataFetched(false);
      setListData([]);
      setTotalPage(0);
    }
  };
  const handleChangePage = (event, newPage) => {
    if (page === newPage) return;
    setPage(newPage);
  };

  return (
    <div className="events6ix-layout-page-middle">
      {loading && <FullPageProgress fixed />}
      <AIChatTabs />
      <div className="events-page-aichat-history">
        <div className="events6ix-tabs mt-0 events-page-aichat-history-top">
          {Object.keys(historyTabs).map((item, key) => (
            <Link
              to={`/ai/history/${item}`}
              key={key}
              className={`events6ix-tabs-item  ${
                item === toggleState ? "active" : ""
              }`}
              onClick={e => {
                if (loading) {
                  return e.preventDefault();
                }
                changeTabs(item);
              }}
            >
              {historyTabs[item]}
            </Link>
          ))}
        </div>

        <div className="events-page-aichat-history-content">
          {listData?.length ? (
            <div className="events-page-aichat-history-content-row">
              {listData.map((listItem, key) => {
                return <AIChatHistoryItem listItem={listItem} key={key} />;
              })}
            </div>
          ) : !loading ? (
            <div className="events-page-aichat-history-content-empty">
              No {listType} history avaible
            </div>
          ) : null}

          {totalPage > 1 && (
            <Flex justify="center" className="text-center mt-20">
              <Pagination
                variant="text"
                onChange={handleChangePage}
                page={page}
                count={totalPage}
              />
            </Flex>
          )}
        </div>
      </div>
    </div>
  );
};

export default AIChatHistory;
